import React, {Component} from "react";
import {Accordion, AccordionItem, AccordionItemBody, AccordionItemTitle} from "react-accessible-accordion";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";
import MediaViewer from "../../einvoice/MediaViewer";
import SweetAlertExt from "../../../components/SweetAlertExt";
import MiniButton from "../../../components/MiniButton";
import moment from "moment";
import SweetAlert from 'react-bootstrap-sweetalert';
import Datetime from "react-datetime/DateTime";
import {Col, UncontrolledTooltip} from "reactstrap";
import {validateComponent, validateField} from "../../../common/validation";
import AliasEditModal from "./AliasEditModal";
import {EntegratorIdentifiers} from "../../../helper/enums";
import {EntegratorConf} from "../../../constants";
import {disAllowChooseContractType, hiddenButton, isVakifbankUser} from "../../../helper/permission";

class CustomerContractAccordion extends Component {

	constructor(props) {
		super(props);

		this.state = {
			page: 0,
			aPage: 0,
			size: 10,
			aSize: 10,
			manual: false,
			aManual: false,
			url: null,
			mediaModal: false,
			serviceList: [],
			aliasList: [],
			customerContractList: [],
			alert: null,
			resendAlert: null,
			contractRenewalAlert: null,
			error: {},
			deleteOn: false,
			resendingServices: {},
			resendingSuccess: {},
			aliasEditModal:false,
			aliasUpdateModalButtonsDisabled:false,
			customerContract: this.props.customerContract,
			isMobile:window.innerWidth > 991 ? false : true
		};

		this.arrangeData = this.arrangeData.bind(this);
		this.arrangeAliasData = this.arrangeAliasData.bind(this);
		this.checkIfEFaturaExists = this.checkIfEFaturaExists.bind(this);
		this.checkIfEIrsaliyeExists = this.checkIfEIrsaliyeExists.bind(this);
		this.cancelAlias = this.cancelAlias.bind(this);
		this.activateAlias = this.activateAlias.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.setMediaViewer = this.setMediaViewer.bind(this);
		this.cancelService = this.cancelService.bind(this);
		this.resendService = this.resendService.bind(this);
		this.updateAlias = this.updateAlias.bind(this);
		this.deleteAlias = this.deleteAlias.bind(this);
		this.deleteService = this.deleteService.bind(this);
		this.isServiceDeletable = this.isServiceDeletable.bind(this);
		this.deleteContract = this.deleteContract.bind(this);
		this.isContractDeletable = this.isContractDeletable.bind(this);
		this.vakifbankManuelCancelService = this.vakifbankManuelCancelService.bind(this);
	}

	componentDidMount() {
		let customerId = this.props.currentCustomer;
		if (this.props.customerContract.recordId !== null && this.props.customerContract.recordId !== undefined) {
			let contract = this.props.customerContract;

			let params = {
				url: `/customer/checkDeleteContract/${customerId}/${contract.recordId}`,
				method: 'get'
			};
			request(params).then((response) => {
				if (response.data === true) {
					this.setState({deleteOn: true});
				} else {
					this.setState({deleteOn: false});
				}
			})
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.customerContract !== this.props.customerContract) {
			this.setState({ customerContract: this.props.customerContract });
		}
		if (prevProps.currentCustomer !== this.props.currentCustomer) {
			this.setState({ currentCustomer: this.props.currentCustomer });
		}
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength && e.target.dataset.vlength;
		let value = e.target.value;

		let result = validateField(rule, boundary, value);
		let error = this.state.error;

		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let result = validateComponent(this);
		this.setState({
			error: result.error
		});
		return result
	}

	checkDateValidity(current, name) {
		let copyCurrent = current.clone();
		if (name === 'contractStartDate') {
			return copyCurrent.isAfter(Datetime.moment().subtract(1, 'days'));
		}
		if (name === 'contractFinishDate') {
			return copyCurrent.isAfter(this.state.selectedStartDate);
		}
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	arrangeAliasData(page, size) {
		this.setState({
			aPage: page,
			aSize: size,
			loading: false
		});
	}

	checkIfEFaturaExists() {
		let isFaturaExists = false;
		this.props.customerContract.customerContractServiceList.map((ccs) => {
			if (ccs.service.recordId === 2) {
				isFaturaExists = true;
			}
		});
		return isFaturaExists;
	}

	checkIfEIrsaliyeExists() {
		let isIrsaliyeExists = false;
		this.props.customerContract.customerContractServiceList.map((ccs) => {
			if (ccs.service.recordId === 6) {
				isIrsaliyeExists = true;
			}
		});
		return isIrsaliyeExists;
	}

	cancelAlias(data) {
		let self = this;
		let params = {
			url: `/customer/cancelAlias`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				self.props.updateAliasList(data);
				Alert.warning('Etiket İptal Edildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({alert: null})
			})
			.catch(function (error) {
				self.setState({alert: null});
				showAxiosError(error);
			});
	}

	updateAlias(data) {
		let self = this;
		let params = {
			url: `/customer/updateAlias`,
			method: 'post',
			data: data
		};

		request(params)
			.then((response) => {
				self.props.updateWorkscopeCode(data);
				self.setState({aliasEditModal: false, aliasUpdateModalButtonsDisabled: false});
				Alert.success('Etiket Güncellendi!', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			})
			.catch(function (error) {
				showAxiosError(error);
				self.setState({aliasUpdateModalButtonsDisabled: false});
			});
	}

    deleteAlias(data) {
        let self = this;
        let params = {
            url: `/customer/deleteAlias`,
            method: 'post',
            data: data
        };

        request(params)
            .then((response) => {
                self.props.deleteAlias(data);
                Alert.success('Etiket Başarıyla Silindi!', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
                self.setState({alert: null});
            })
            .catch(function (error) {
                showAxiosError(error);
                self.setState({alert: null});
            });
    }

	deleteService(data) {
		let self = this;
		let params = {
			url: `/customer/deleteService/${self.props.currentCustomer}`,
			method: 'post',
			data: data
		};

		request(params)
			.then((response) => {
				self.props.deleteService(data);
				Alert.success('Servis Başarıyla Silindi!', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({alert: null});
				this.props.accordionDeleteSelectList(data);
			})
			.catch(function (error) {
				showAxiosError(error);
				self.setState({alert: null});
			});
	}

    deleteContract(data) {
        let self = this;
        let params = {
            url: `/customer/deleteContract/${self.props.currentCustomer}`,
            method: 'post',
            data: data
        };

        request(params)
            .then(() => {
                self.props.deleteContract(data);
                Alert.success('Sözleşme Silindi', {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 5000
                });
            }).then(() => {
            self.setState({alert: null});
        })
            .catch(function (error) {
                showAxiosError(error);
				self.setState({alert: null});
            });
    }

	activateAlias(data) {
		let params = {
			url: `/customer/activateAlias`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				this.props.updateAliasList(data);
				Alert.success('Etiket Aktif Edildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				this.setState({alert: null})
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	defineAliasList(data) {

		let aliasList = [];

		data.customerContractServiceList.map((ccs) => {
			if (((ccs.service.ublName === 'EFatura' || ccs.service.recordId === 2)) ||
				((ccs.service.ublName === 'EIrsaliye' || ccs.service.recordId === 6))) {
				ccs.aliasList.map((alias) => {
					aliasList.push(alias);
				});
			}
		});

		const aliasColumns = [
			{
				Header: "Etiket",
				title: "Etiket",
				accessor: "workScopecode",
				sortable: false
			},
			{
				Header: "Hizmet",
				title: "Hizmet",
				accessor: "",
				sortable: false,
				Cell: row => (
					<div>
						<label>{((typeof row.service === 'object' && row.service.recordId === 2) || row.service === 2) ? 'E-Fatura' :
							((typeof row.service === 'object' && row.service.recordId === 6) || row.service === 6 ? 'E-İrsaliye' : '')}</label>
					</div>
				)
			},
			{
				Header: "Birim",
				title: "Birim",
				accessor: "userRolecode",
				sortable: false
			},
			{
				Header: "",
				title: "İşlemler",
				Cell: row => (
					<div>
						{(this.props.isEntegrator || this.props.isDistributor) &&
						(row.actionType === 'P' && row.processState === 500 && row.processResult === 1300) &&
						hiddenButton(this.props.isEntegrator, EntegratorConf.identifier, this.props.currentUser.customerId) && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Etiket İptal Et"
								style={{background: 'linear-gradient(rgb(255, 140, 102), rgb(249, 99, 50))'}}
								rel="tooltip"
								className="Btn btn-icon" onClick={() => {
							this.setState({
								alert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.cancelAlias(row)}
												   onCancel={() => this.setState({alert: null})}
									>
										{row.workScopecode + ' etiketi iptal edilecek.'}
									</SweetAlertExt>
								)
							});

						}}>
							<i className="BtnIcon fas fa-ban"/>
						</button>}
						{ (this.props.isEntegrator || this.props.isDistributor) &&
						(row.actionType === 'C' && row.processState === 500 && row.processResult === 1300) && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Etiket Aktif Et"
								style={{background: 'linear-gradient(#78b1d7, #47a3e0)'}}
								rel="tooltip"
								className="Btn btn-icon"
								onClick={() => {
									this.setState({
										alert: (
											<SweetAlertExt showCancel warning
														   confirmBtnText="Evet"
														   cancelBtnText="Hayır"
														   confirmBtnBsStyle="danger"
														   cancelBtnBsStyle="default"
														   title="Emin misiniz?"
														   onConfirm={() => this.activateAlias(row)}
														   onCancel={() => this.setState({alert: null})}
											>
												{row.workScopecode + ' etiketi aktif edilecek.'}
											</SweetAlertExt>
										)
									});
								}}>
							<i className="BtnIcon fas fa-redo"/>
						</button>}

						{(row.actionType === 'P' && (row.processState <= 130 || (row.processState === 500 && this.checkFor1182([row])))) &&
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Etiketi Düzenle"
								style={{background: 'linear-gradient(rgb(116 172 210), rgb(56 146 208))'}}
								rel="tooltip"
								className="Btn btn-icon"
								onClick={() => {this.setState({ aliasForUpdate: row, aliasEditModal: true });}} >
							<i className="BtnIcon fas fa-edit"/>
						</button>}

						{(row.actionType === 'P' && row.processState <= 130) && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Etiketi Sil"
								style={{background: 'linear-gradient(rgb(202 66 21), rgb(233 63 51 / 75%))'}}
								rel="tooltip"
								className="Btn btn-icon"
								onClick={() => {
							this.setState({
								alert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.deleteAlias(row)}
												   onCancel={() => this.setState({alert: null})}
									>
										{row.workScopecode + ' etiketi silinecek, onaylıyor musunuz?'}
									</SweetAlertExt>
								)
							});
						}}>
                            <i className="BtnIcon fas fa-trash"></i>
						</button>}
					</div>
				)
			}
		];

		return (
			<div style={{marginTop: '30px'}}>
				{(this.checkIfEFaturaExists() || this.checkIfEIrsaliyeExists()) &&
				<div className="col-sm-12">
					<hr style={{margin: '0 0 20px 0'}}/>
				</div>}

				{(this.checkIfEFaturaExists() || this.checkIfEIrsaliyeExists()) && 
				!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
				<div className="col-sm-12 row">
					<div className='col-sm-2' style={{padding: '17px 0 0 0'}}>
						<h6>Kayıtlı Etİketler</h6>
					</div>
					<div className="col-sm-8"></div>
					<div className="col-sm-2" style={{padding: '8px 0 0 0'}}>
						{((this.props.isEntegrator || this.props.isDistributor) && aliasList.length !== 0) &&
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{
									background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
									marginBottom: '12px'
								}}
								rel="tooltip" className="TekBtn ekle btn-icon" disabled={this.props.fieldsDisabled}
								onClick={() => {
									this.props.addNewAliasToContract()
								}}>Yenİ Etİket Ekle
						</button>}
					</div>
				</div>}

				{(this.checkIfEFaturaExists() || this.checkIfEIrsaliyeExists()) &&
				<div className="col-sm-12">
					<Table
						columns={aliasColumns}
						content={aliasList}
						page={this.state.aPage}
						size={this.state.aSize}
						total={aliasList.length}
						paginationEnabled={false}
					/>
				</div>}
			</div>
		)
	}

	handleShow(row) {
		let self = this;

		let formData = new FormData();
		formData.append("recordId", row.recordId);

		let params = {
			url: `/customer/getContract`,
			responseType: 'arraybuffer',
			method: "post",
			data: formData
		};
		self.setState({mediaModal: true, title: "Sözleşme PDF"});

		request(params)
			.then(function (response) {
				let blob = new Blob([response.data], {type: response.headers["content-type"]});
				let urlCreator = window.URL || window.webkitURL;
				let url = urlCreator.createObjectURL(blob);
				self.setState({url: url});

			}).catch(function (error) {
			if (error.response === undefined) {
				showAxiosError({message: "Şuan işleminiz gerçekleştirilemiyor."});
			} else {
				let enc = new TextDecoder("utf-8");
				showAxiosError({message: enc.decode(error.response.data)});
			}
			self.setState({mediaModal: false, title: null});
		});
	}

	setMediaViewer() {
		this.setState({url: null, mediaModal: false});
	}

	cancelService(data) {
		let self = this;
		let params = {
			url: `/customer/cancelService`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				self.props.updateAliasList(data);
				Alert.warning('Hizmet İptal Edildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({alert: null});
			}).then(() => self.props.reFetchCustomer())
			.catch(function (error) {
				self.setState({alert: null});
				showAxiosError(error);
			});
	}

	vakifbankManuelCancelService(data) {
		let self = this;
		let params = {
			url: `/customer/manuelCancelVakifbankService`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				self.props.updateAliasList(data);
				Alert.warning('Hizmet İptal Edildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({alert: null});
			}).then(() => self.props.reFetchCustomer())
			.catch(function (error) {
				self.setState({alert: null});
				showAxiosError(error);
			});

	}

	reActivateService(data) {
		let self = this;
		let params = {
			url: `/customer/reActivateService`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				Alert.warning('Hizmet Tekrar Aktif Edildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({alert: null});
			}).then(() => self.props.reFetchCustomer())
			.catch(function (error) {
				self.setState({alert: null});
				showAxiosError(error);
			});
	}

	resendService(data) {
		let {resendingServices, resendingSuccess} = this.state;
		resendingServices[data.ublCode] = true;
		this.setState({resendAlert: null, resendingServices});
		let self = this;
		request({
			url: `/customer/resendService`,
			method: 'post',
			data: data.aliasList
		})
			.then(() => {
				Alert.success('Hizmet Tekrar Gönderildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				resendingServices[data.service.ublCode] = false;
				resendingSuccess[data.service.ublCode] = true;
				self.setState({resendingSuccess, resendingServices});
			})
			.catch(function (error) {
				resendingServices[data.service.ublCode] = false;
				resendingSuccess[data.service.ublCode] = false;
				self.setState({resendAlert: null, resendingServices, resendingSuccess});
				showAxiosError(error);
			});
	}

	checkFor1182(data) {
		let found = false;
		data.map(d => {
			if (
				(d.processState === 500 && (
					d.processResult === 1150 || d.processResult === 1181 || d.processResult === 1182 || d.processResult === 1183
					|| d.processResult === 1195 || d.processResult === 1177 || d.processResult === 3000
					|| d.processResult === 2005 || d.processResult === 1120 || d.processResult === 1130))
				|| ((d.processState === 180 || d.processState === 120) && (d.processResult === 3))) {
				found = true;
			}
		});
		return found;
	}

	isServiceDeletable(row){
		if(['E-Arsiv', 'E-Fatura', 'E-İrsaliye' ].includes(row.service.ublCode)) {
			return	row.aliasList.length === row.aliasList.filter(alias => (alias.actionType === 'P' && alias.processState <= 180)).length
		}else{
			return true;
		}
	}

    isContractDeletable(data){
        let result = true;

	    for(let i=0; i< data.customerContractServiceList.length; i++){
            if (! this.isServiceDeletable(data.customerContractServiceList[i])){
                result = false;
                break;
            }
        }
	    return result;
    }

	handleEditContractDates(contract, event, type) {
		let contractId = contract.recordId;

		if (type === 'contractStartDate') {
			if (!(typeof event === "string")) {
				let newStartDate = event.format("YYYY-MM-DD");
				let newFinishDate = event.clone().add(1, 'years').format('YYYY-MM-DD');

				this.props.updateContractDates(contractId, newStartDate, newFinishDate);
			}
		} else {
			if (!(typeof selection === "string")) {
				let newFinishDate = event.format("YYYY-MM-DD");

				this.props.updateContractDates(contractId, null, newFinishDate);
			}
		}

	}

	updateContractDates(data) {
		let self = this;
		let params = {
			url: `/customer/updateContractDates`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				Alert.success('Sözleşme Tarihleri Güncellendi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.props.completeUpdate();
				self.setState({alert: null})
			})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

	cancelContract(data) {
		let self = this;
		let params = {
			url: `/customer/cancelContract`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				Alert.success('Sözleşme İptal Talebi Gönderildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}).then(() => {
			self.setState({alert: null}, () => self.showHideFakeElementsForCancellation(data.recordId));
		})
			.catch(function (error) {
				self.setState({alert: null});
				showAxiosError(error);
			});
	}

	activateContract(data) {
		let self = this;
		let params = {
			url: `/customer/activateContract`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				Alert.success('Sözleşme Aktivasyon Talebi Gönderildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
			}).then(() => {
			self.setState({alert: null}, () => self.showHideFakeElementsForActivation(data.recordId));
		})
			.catch(function (error) {
				showAxiosError(error);
			});
	}

    showHideFakeElementsForCancellation(id) {
		document.getElementById('fake-cancel-warning-' + id).style["display"] = "unset";
		document.getElementById('accordion-item-title-' + id).style["background"] = "#fffb5fad";
		document.getElementById('accordion-item-title-' + id).style["color"] = "#A1A1A1";
		document.getElementById('accordion-item-title-' + id).style["font-size"] = "10px";
		document.getElementById('accordion-body-' + id).style["background"] = "#fffb5fad";
		document.getElementById('cancel-contract-button-' + id).style["display"] = "none";
	}

	showHideFakeElementsForActivation(id) {
		document.getElementById('cancelled-contract-warning-' + id).style["display"] = "none";
		document.getElementById('fake-activate-warning-' + id).style["display"] = "unset";
		document.getElementById('accordion-item-title-' + id).style["background"] = "#7fff5fad";
		document.getElementById('accordion-item-title-' + id).style["color"] = "#A1A1A1";
		document.getElementById('accordion-item-title-' + id).style["font-size"] = "10px";
		document.getElementById('accordion-body-' + id).style["background"] = "#7fff5fad";
		document.getElementById('activate-contract-button-' + id).style["display"] = "none";
	}

	warnContractCancellation(data) {
		this.setState({
			alert: (

				<SweetAlert showCancel
							warning
							title="Uyarı"
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							onConfirm={() => this.cancelContract(data)}
							onCancel={() => this.setState({alert: null})}
				>
					<div style={{maxHeight: '200px', overflowY: 'auto'}}>
						<p>Aşağıda bilgileri verilmiş sözleşmenin iptal edilmesini onaylıyor musunuz ?</p>
						<ul>
							<li>
								Sözleşme Tarihi : {data.contractStartDate} - {data.contractFinishDate}
							</li>
							<li>
								Hizmetler : {this.previewServices(data, false)}
							</li>
						</ul>
					</div>
				</SweetAlert>
			)
		})
	}

	warnContractActivation(data) {
		this.setState({
			alert: (

				<SweetAlert showCancel
							warning
							title="Uyarı"
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							onConfirm={() => this.activateContract(data)}
							onCancel={() => this.setState({alert: null})}
				>
					<div>
						<p>Aşağıda bilgileri verilmiş sözleşmenin aktif edilmesini onaylıyor musunuz ?</p>
						<ul>
							<li>
								Sözleşme Tarihi : {data.contractStartDate} - {data.contractFinishDate}
							</li>
							<li>
								Hizmetler : {this.previewServices(data, true)}
							</li>
						</ul>
					</div>
				</SweetAlert>
			)
		})
	}

    warnContractDeletion(data) {
        this.setState({
            alert: (

                <SweetAlert showCancel
                            warning
                            title="Uyarı"
                            confirmBtnText="Evet"
                            cancelBtnText="Hayır"
                            confirmBtnBsStyle="danger"
                            cancelBtnBsStyle="default"
                            onConfirm={() => this.deleteContract(data)}
                            onCancel={() => this.setState({alert: null})}
                >
                    <div>
                        <p>Aşağıda bilgileri verilmiş sözleşmenin silinmesini onaylıyor musunuz ?</p>
                        <ul>
                            <li>
                                Sözleşme Tarihi : {data.contractStartDate} - {data.contractFinishDate}
                            </li>
                            <li>
                                Hizmetler : {this.previewServices(data, false)}
                            </li>
                        </ul>
                    </div>
                </SweetAlert>
            )
        })
    }

	isActiveContract(data) {
		let ccsl = data.customerContractServiceList;
		let active = true;

		if (ccsl !== null && ccsl.length > 0) {
			let foundActiveAlias = false;

			for (let service in ccsl) {

				let al = ccsl[service].aliasList;
				if (al !== null && al.length > 0) {
					for (let alias in al) {
						if (!(al[alias].actionType === 'C' && al[alias].processState === 500 && al[alias].processResult === 1300)) {
							foundActiveAlias = true;
							break;
						}
					}
				}

				if (foundActiveAlias) {
					break;
				}
			}

			active = foundActiveAlias;

			return active;
		}
	}

	shouldRenderContractActivationButtons(data) {

		if (data.recordId) {
			let ccsl = data.customerContractServiceList;
			let cancelled = false;
			let pendingCancelSign = false;
			let pendingActivateSign = false;

			let result = {};

			if (ccsl !== null && ccsl.length > 0) {
				let foundActiveAlias = false;

				for (let service in ccsl) {

					let al = ccsl[service].aliasList;
					if (al !== null && al.length > 0) {
						for (let alias in al) {
							if ((al[alias].actionType === 'C' && al[alias].processState === 500 && al[alias].processResult === 1300) === false) {
								foundActiveAlias = true;

								if (al[alias].processState <= 130 && al[alias].processResult === 0 && al[alias].actionType === 'C') {
									if (pendingCancelSign === false) {
										pendingCancelSign = true;
									}
								}

								if (al[alias].processState <= 130 && al[alias].processResult === 0 && al[alias].actionType === 'P') {
									if (pendingActivateSign === false) {
										pendingActivateSign = true;
									}
								}
							}
						}
					}
				}

				if (foundActiveAlias === false && pendingCancelSign === false && pendingActivateSign === false) {
					cancelled = true;
				}
				result.cancelled = cancelled
			}

			result.cancelled = cancelled;
			result.pendingCancelSign = pendingCancelSign;
			result.pendingActivateSign = pendingActivateSign;

			return result;
		} else {
			let result = {};

			result.cancelled = false;
			result.pendingActivateSign = true;
			result.pendingCancelSign = false;

			return result;
		}
	}

	shouldRenderServiceButton(row, data) {
		let result = {};
		let contractStatus = this.shouldRenderContractActivationButtons(data);

		if (contractStatus.cancelled) {
			result.reactivate = true;
			result.deactivate = false;
			result.resend = false;

		} else if (contractStatus.cancelled === false && contractStatus.pendingCancelSign === false && contractStatus.pendingActivateSign === false) {
			if (row.aliasList.length > 0) {
				let foundInactiveAlias = false;
				let foundActiveAlias = false;
				row.aliasList.map(a => {
					if (a.actionType === 'C' && a.processState === 500 && a.processResult === 1300) {
						foundInactiveAlias = true;
					}

					if (a.actionType === 'P' && a.processState === 500 && a.processResult === 1300) {
						foundActiveAlias = true;
					}
				});

				if (foundInactiveAlias) {
					result.reactivate = true;
				} else {
					result.reactivate = false;
				}

				if (foundActiveAlias) {
					result.deactivate = true;

				} else {
					result.deactivate = false;
				}
			} else {
				result.reactivate = false;
				result.deactivate = false;
			}
			result.resend = true;
		} else {
			result.reactivate = false;
			result.deactivate = false;
			result.resend = false;
		}

		if (data.recordId === 3226) {
			console.log('contractStatus: %o%o', data.recordId, contractStatus);
			console.log('result: %o', result);
			console.log('row & data: %o%o', row, data);
		}


		return result;
	}

	shouldRenderAliasButton(row, data) {
		let result = {};
		let contractStatus = this.shouldRenderContractActivationButtons(data);

		if (!contractStatus.cancelled && !contractStatus.pendingCancelSign && !contractStatus.pendingActivateSign) {
			if (row.actionType === 'P' && row.processState === 500 && row.processResult === 1300) {
				result.reactivate = false;
				result.deactivate = true;
			}

			if (row.actionType === 'C' && row.processState === 500 && row.processResult === 1300) {
				result.reactivate = true;
				result.deactivate = false;
			}
		} else {
			result.reactivate = false;
			result.deactivate = false;
		}

		return result;
	}


	defineBody(data) {

		let activationButtonState = this.shouldRenderContractActivationButtons(data);
		let serviceList = [];
		let isContractDateEditable = true;

		data.customerContractServiceList.map((ccs) => {
			let copyCcs = ccs;
			if (ccs.service.recordId === 1) {
				copyCcs.ublCode = 'E-Arsiv'
			} else if (ccs.service.recordId === 2) {
				copyCcs.ublCode = 'E-Fatura'
			} else if (ccs.service.recordId === 3) {
				copyCcs.ublCode = 'E-Defter'
			} else if (ccs.service.recordId === 4) {
				copyCcs.ublCode = 'Saklama'
			} else if (ccs.service.recordId === 5) {
				copyCcs.ublCode = 'E-Defter Yukleme'
			} else if (ccs.service.recordId === 6) {
				copyCcs.ublCode = 'E-İrsaliye'
			} else if (ccs.service.recordId === 7) {
				copyCcs.ublCode = 'SMM'
			} else if (ccs.service.recordId === 8) {
				copyCcs.ublCode = 'MM'
			} else if (ccs.service.recordId === 88) {
				copyCcs.ublCode = 'Defter Kontrol'
			} else if (ccs.service.recordId === 122) {
				copyCcs.ublCode = 'E-Gider Pusulası'
			} else if (ccs.service.recordId === 9) {
				copyCcs.ublCode = 'Mali Rapor (Eski OKC)'
			} else if (ccs.service.recordId === 10) {
				copyCcs.ublCode = 'Mali Rapor (Yeni OKC)'
			} else if (ccs.service.recordId === 12) {
				copyCcs.ublCode = 'E-Adisyon'
			} else if (ccs.service.recordId === 77) {
				copyCcs.ublCode = 'İK Platformu'
			} else if (ccs.service.recordId === 99) {
				copyCcs.ublCode = 'Ön Muhasebe'
			} else if (ccs.service.recordId === 121) {
				copyCcs.ublCode = 'E-Defter İkincil Kopya'
			} else if (ccs.service.recordId === 13) {
				copyCcs.ublCode = 'E-Belge'
			} else if (ccs.service.recordId === 123) {
				copyCcs.ublCode = 'E-Konnektör'
			} else if (ccs.service.recordId === 11) {
				copyCcs.ublCode = 'E-Döviz'
			} else if (ccs.service.recordId === 124) {
				copyCcs.ublCode = 'e-Arşiv 5000/3000'
			} else if (ccs.service.recordId === 125) {
				copyCcs.ublCode = 'E-Sigorta'
			} else if (ccs.service.recordId === 140) {
				copyCcs.ublCode = 'E-Ticaret'
			} else {
				copyCcs.ublCode = ccs.service.ublCode;
			}
			serviceList.push(copyCcs);

			if (isContractDateEditable) {
				ccs.aliasList.map(alias => {
					if (alias.actionType === "P" && alias.processState === 500 && alias.processResult === 1300 && alias.gibRegistrationState === true && [1,2,6].includes(alias.service.recordId)) {
						isContractDateEditable = false;
					}
				});
			}
		});

		const serviceColumns = [
			{
				Header: "Hizmet",
				title: "Hizmet",
				accessor: "ublCode",
				sortable: false
			},
			{
				Header: "Ücret",
				title: "Ücret",
				accessor: "price",
				sortable: false,
				Cell: row => (
					<div>
						{(this.props.customerContract && (this.props.customerContract.signatureState !== 'VALIDATED' || (this.props.isEntegrator && this.props.currentUser.adminUser))) &&
						<span><input value={row.price} onChange={(e) => this.props.onChangeInvalidatedContractPrice(e, row)}/><label>₺</label></span>}
						{(this.props.customerContract && (this.props.customerContract.signatureState === 'VALIDATED' && !this.props.isEntegrator)) &&
						<label>{row.price !== null ? row.price + " ₺" : "-"}</label>}
					</div>
				)
			},
			{
				Header: "Açıklama",
				title: "Açıklama",
				accessor: "explanation",
				sortable: false,
				Cell: row => (
					<div>
						{(this.props.customerContract && (this.props.customerContract.signatureState !== 'VALIDATED' || (this.props.isEntegrator && this.props.currentUser.adminUser))) &&
						<span><input value={row.explanation} onChange={(e) => this.props.onChangeInvalidatedContractExplanation(e, row)}/>{this.state.isMobile && <label style={{visibility:'hidden'}}>₺</label>}</span>}
						{(this.props.customerContract && (this.props.customerContract.signatureState === 'VALIDATED' && !this.props.isEntegrator)) &&
						<label>{row.explanation !== null ? row.explanation : "-"}</label>}
					</div>
				)
			},
			{
				Header: "",
				title:'İşlemler',
				accessor: "",
				sortable: false,
				Cell: row => (
					<div>
						{((this.props.isEntegrator || this.props.isDistributor) && row.recordId) &&
						this.shouldRenderServiceButton(row, data).deactivate &&
						hiddenButton(this.props.isEntegrator, EntegratorConf.identifier, this.props.currentUser.customerId) && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Hizmet İptal Et"
								style={{background: 'linear-gradient(rgb(255, 140, 102), rgb(249, 99, 50))'}}
								rel="tooltip"
								className="Btn btn-icon" onClick={() => {
							this.setState({
								alert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.cancelService(row)}
												   onCancel={() => this.setState({alert: null})}
									>
										{row.service.ublCode + " hizmeti iptal edilecek."}
									</SweetAlertExt>
								)
							});
						}}>
							<i className="BtnIcon fas fa-ban"/>
						</button>}

						{((this.props.isEntegrator || this.props.isDistributor) && row.recordId) &&
							(row.aliasList.filter(item => (item.actionType === 'P' && item.processState === 130  && item.processResult === 0)).length > 0) &&
							!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
							<button type="button"
									data-toggle="tooltip" data-placement="bottom" title="Vakifbank Manuel İptal"
									style={{background: 'linear-gradient(rgb(255, 140, 102), rgb(249, 99, 50))'}}
									rel="tooltip"
									className="Btn btn-icon" onClick={() => {
								this.setState({
									alert: (
										<SweetAlertExt showCancel warning
													   confirmBtnText="Evet"
													   cancelBtnText="Hayır"
													   confirmBtnBsStyle="danger"
													   cancelBtnBsStyle="default"
													   title="Emin misiniz?"
													   onConfirm={() => this.vakifbankManuelCancelService(row)}
													   onCancel={() => this.setState({alert: null})}
										>
											{row.service.ublCode + " hizmeti iptal edilecek."}
										</SweetAlertExt>
									)
								});
							}}>
								<i className="BtnIcon far fa-times-circle"/>
							</button>}

						{((this.props.isEntegrator || this.props.isDistributor) && row.recordId) &&
						(row.terminated && row.terminationDate !== null) &&
						(row.aliasList.filter(item => !(item.actionType === 'C' && item.processState === 500  && item.processResult === 1300)).length === 0) && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Hizmeti Tekrar Aktif Et"
								style={{background: 'linear-gradient(#93db84, #5eba59)'}}
								rel="tooltip"
								className="Btn btn-icon" onClick={() => {
							this.setState({
								alert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.reActivateService(row)}
												   onCancel={() => this.setState({alert: null})}
									>
										{"Daha önce iptal edilmiş " + row.service.ublCode + " hizmeti tekrar aktif edilecek."}
									</SweetAlertExt>
								)
							});
						}}>
							<i className="BtnIcon fas fa-redo"/>
						</button>}

						{((this.props.isEntegrator || this.props.isDistributor) && row.recordId && ((typeof row.service === 'object'
							&& (row.service.ublCode === 'E-Arsiv' || row.service.ublCode === 'E-Fatura' || row.service.ublCode === 'E-İrsaliye' || row.service.ublCode === 'SMM' || row.service.ublCode === 'MM'))
							&& (row.aliasList.length > 0 && this.checkFor1182(row.aliasList))))
						&& !this.state.resendingSuccess[row.service.ublCode]
						&& (!activationButtonState.cancelled && !activationButtonState.pendingActivateSign && !activationButtonState.pendingCancelSign) &&
						this.shouldRenderServiceButton(row, data).resend && 
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Tekrar Gönder"
								style={{background: 'linear-gradient(rgb(232, 234, 79), rgb(214, 199, 26))'}}
								rel="tooltip"
								className="Btn btn-icon" disabled={this.state.resendingServices[row.service.ublCode]} onClick={() => {
							this.setState({
								resendAlert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.resendService(row)}
												   onCancel={() => this.setState({resendAlert: null})}
									>
										{row.service.ublCode + " hizmeti tekrar gönderilecek."}
									</SweetAlertExt>
								)
							});
						}}>
							<i className="BtnIcon fas fa-share-square"/>
						</button>}



						{( row.recordId && this.props.customerContract.signatureState !== 'VALIDATED') &&
							this.isServiceDeletable(row) && !isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) && 
						<button type="button"
								data-toggle="tooltip" data-placement="bottom" title="Hizmeti Sil"
								style={{background: 'linear-gradient(rgb(202 66 21), rgb(233 63 51 / 75%))'}}
								rel="tooltip"
								className="Btn btn-icon" onClick={() => {
							this.setState({
								alert: (
									<SweetAlertExt showCancel warning
												   confirmBtnText="Evet"
												   cancelBtnText="Hayır"
												   confirmBtnBsStyle="danger"
												   cancelBtnBsStyle="default"
												   title="Emin misiniz?"
												   onConfirm={() => this.deleteService(row)}
												   onCancel={() => this.setState({alert: null})}
									>
										{row.service.ublCode + " hizmeti silinecek."}
									</SweetAlertExt>
								)
							});
						}}>
							<i className="BtnIcon fas fa-trash"></i>
						</button>}

						{this.state.isMobile && <span style={{visibility:'hidden'}}>|</span>}


					</div>
				)
			}
		];

		return (
			<div>
				<div className="col-sm-12 row">
                    {((this.props.isEntegrator || this.props.isDistributor) &&
					(data.recordId && this.state.deleteOn === true) &&
                    this.isContractDeletable(data) && 
					!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier)) &&
                    <Col id={'activate-contract-button-' + data.recordId} xs='12'
                         style={{
                             margin: '-10px 0 10px 0',
                             borderRadius: '5px',
                             border: '1px solid #dadada',
                             background: '#ff070712'
                         }}>
                        <button  onClick={() => this.warnContractDeletion(data)} disabled={this.props.fieldsDisabled} className='btn' style={{background: '#b86e28'}}>Sözleşmeyi Sil
                        </button>
                    </Col>}


                    {(this.props.isEntegrator || this.props.isDistributor) && !activationButtonState.cancelled && !activationButtonState.pendingCancelSign &&
						!activationButtonState.pendingActivateSign && this.props.customerContract.signatureState === 'VALIDATED' && 
						!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
					<Col id={'cancel-contract-button-' + data.recordId} xs='12'
						 style={{
							 margin: '-10px 0 10px 0',
							 borderRadius: '5px',
							 border: '1px solid #dadada',
							 background: '#ff070712'
						 }}>

						{hiddenButton(this.props.isEntegrator, EntegratorConf.identifier, this.props.currentUser.customerId) &&
						<button onClick={() => this.warnContractCancellation(data)}	className='btn' style={{background: '#b81717'}}>Sözleşmeyi İptal Et</button>}
					</Col>}

					{(this.props.isEntegrator || this.props.isDistributor) && 
					activationButtonState.cancelled && !activationButtonState.pendingActivateSign &&
					!isVakifbankUser(this.props.parentCustomerId, EntegratorConf.identifier) &&
					<Col id={'activate-contract-button-' + data.recordId} xs='12'
						 style={{
							 margin: '-10px 0 10px 0',
							 borderRadius: '5px',
							 border: '1px solid #dadada',
							 background: '#07ff1a61'
						 }}>
						<button onClick={() => this.warnContractActivation(data)} disabled={this.props.fieldsDisabled} className='btn' style={{background: '#17b857'}}>Sözleşmeyi Aktif Et
						</button>
					</Col>}

					{(((this.props.isEntegrator && this.props.isAdminUser)
						|| ([EntegratorIdentifiers.KOLAYSOFT,EntegratorIdentifiers.SMART,EntegratorIdentifiers.MEDIFATURA,EntegratorIdentifiers.ZIRVE].includes(EntegratorConf.identifier)
							&& (this.props.currentUser.roleId && (this.props.currentUser.roleId === 5 || this.props.currentUser.roleId === 3 || this.props.currentUser.roleId === 4))))
					&& (isContractDateEditable || [EntegratorIdentifiers.HIZLI, EntegratorIdentifiers.ZIRVE].includes(EntegratorConf.identifier))) ?
						<div className='col-sm-10 row'
							 style={{borderStyle: 'solid', borderWidth: '1px', borderRadius: '3px', borderColor: '#dadada', margin: '0'}}>
							<div className="col-sm-5">
								<label className="col-sm-12 col-form-label">Sözleşme Başlangıç Tarihi *</label>
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass("tContractStartDate")}>
										<Datetime locale="tr"
												  className="datepicker"
												  input={true}
												  inputProps={{
													  id: 'tContractStartDate',
													  dataset: {
														  vdata: "date",
														  vlength: "1,255",
														  value: data.contractStartDate
													  }
												  }}
												  onBlur={(momentObj) => this.validateField({
													  target: {
														  id: "tContractStartDate",
														  dataset: {'vdata': "required", 'vlength': "1,255"},
														  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
													  }
												  })}
												  closeOnSelect={false}
												  value={moment(data.contractStartDate).format('DD-MM-YYYY')}
												  dateFormat="DD-MM-YYYY"
												  ref="tContractStartDate"
												  isValidDate={(current) => this.checkDateValidity(current, 'contractStartDate')}
												  timeFormat={false}
												  onChange={(e) => this.handleEditContractDates(data, e, 'contractStartDate')}/>
										{this.validateMessage("tContractStartDate") !== "" &&
										<UncontrolledTooltip placement="right" target={"tContractStartDate"} delay={0}>
											{this.validateMessage("tContractStartDate")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							<div className="col-sm-5">
								<label className="col-sm-12 col-form-label">Sözleşme Bitiş Tarihi *</label>
								<div className="col-sm-12">
									<div className={"form-group" + this.validateClass("tContractFinishDate")}>
										<Datetime locale="tr"
												  className="datepicker"
												  input={true}
												  inputProps={{
													  id: 'tContractFinishDate',
													  dataset: {
														  vdata: "date",
														  vlength: "1,255",
														  value: data.contractFinishDate
													  }
												  }}
												  onBlur={(momentObj) => this.validateField({
													  target: {
														  id: "tContractFinishDate",
														  dataset: {'vdata': "required", 'vlength': "1,255"},
														  value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
													  }
												  })}
												  closeOnSelect={false}
												  value={moment(data.contractFinishDate).format('DD-MM-YYYY')}
												  dateFormat="DD-MM-YYYY"
												  ref="tContractFinishDate"
												  isValidDate={(current) => this.checkDateValidity(current, 'contractFinishDate')}
												  timeFormat={false}
												  onChange={(e) => this.handleEditContractDates(data, e, 'contractFinishDate')}/>
										{this.validateMessage("tContractFinishDate") !== "" &&
										<UncontrolledTooltip placement="right" target={"tContractFinishDate"} delay={0}>
											{this.validateMessage("tContractFinishDate")}
										</UncontrolledTooltip>}
									</div>
								</div>
							</div>

							{(this.props.isEntegrator || this.props.isDistributor) && (this.props.currentStartDate !== null || this.props.currentFinishDate !== null) && data.recordId === this.props.currentContractId &&
							<div className='col-sm-2'>
								<button type="button"
										title="Yeni Tarihi Kaydet"
										style={{background: '#1db954'}}
										className="btn btn-md btn-icon"
										onClick={() => this.updateContractDates(data)}>
									<i class="fas fa-check"/>
								</button>
							</div>}
						</div>

						:
						<div className='col-sm-10 row'
							 style={{margin: '0'}}>
							<div className="col-sm-5">
								<div className="col-sm-12">
									<label className="col-form-label">Sözleşme Başlangıç Tarihi: </label>
								</div>
								<div className="col-sm-12">
									<label className="col-form-label">
										{data.contractStartDate && moment(data.contractStartDate).isValid() ?
											moment(data.contractStartDate).format('DD-MM-YYYY') : "-"}
									</label>
								</div>
							</div>

							<div className="col-sm-5">
								<div className="col-sm-12">
									<label className="col-form-label">Sözleşme Bitiş Tarihi: </label>
								</div>
								<div className="col-sm-12">
									<label className="col-form-label">
										{data.contractFinishDate && moment(data.contractFinishDate).isValid() ?
											moment(data.contractFinishDate).format('DD-MM-YYYY') : "-"}
									</label>
								</div>
							</div>
						</div>}


					<div className="col-sm-2 row" style={{margin: '0'}}>
						<div className="col-sm-8">
							<label className="col-form-label">Sözleşme PDF: </label>
						</div>
						<div className="col-sm-4">
							<button type="button"
									title="Sözleşme Görüntüle"
									style={{marginTop: "0px", backgroundColor: '#ec3333'}}
									className="btn btn-md btn-icon"
									onClick={() => this.handleShow(data)}>
								<i className="fa fa fa-file-pdf-o"/>
							</button>
						</div>
					</div>
				</div>
				<hr/>

				<h6 style={{marginTop: '30px', marginBottom: '10px'}}>Sözleşmeye Dahİl Hİzmetler</h6>
				<div key={this.state.serviceKey} className="col-sm-12">
					<Table
						columns={serviceColumns}
						content={serviceList}
						page={this.state.page}
						size={this.state.size}
						total={this.state.serviceList.length}
						paginationEnabled={false}
					/>
				</div>
			</div>
		)
	}

	previewServices(contract, showDeletedServices) {
		let servicesString = '';
		if (contract.customerContractServiceList && contract.customerContractServiceList.length !== 0) {
			let services = contract.customerContractServiceList.filter(ccs => ccs.terminated === showDeletedServices);
			let length = services.length;
			services.map(s => {
				if (typeof s.service !== 'object') {
					if (services.indexOf(s) === length - 1) {
						servicesString += this.selectServiceName(s.service) + ', ';
					} else {
						servicesString += this.selectServiceName(s.service) + ', ';
					}
				} else {
					if (services.indexOf(s) === length - 1) {
						if(!s.service.ublCode){
							servicesString += this.selectServiceName(s.service.recordId);
						}
						else{
							servicesString += s.service.ublCode;
						}
					} else {
						if(!s.service.ublCode){
							servicesString += this.selectServiceName(s.service.recordId) + ', ';
						}
						else{
							servicesString += s.service.ublCode + ', ';
						}
					}
				}
			});
		} else {
			servicesString = '-';
		}
		return servicesString;
	}

	selectServiceName(serviceId) {
		switch (serviceId) {
			case 1 :
				return 'E-Arsiv';
			case 2 :
				return 'E-Fatura';
			case 3 :
				return 'E-Defter';
			case 4 :
				return 'Saklama';
			case 5 :
				return 'E-Defter Saklama';
			case 6 :
				return 'E-İrsaliye';
			case 7 :
				return 'SMM';
			case 8 :
				return 'MM';
			case 88 :
				return 'Defter Kontrol';
			case 9 :
				return 'Mali Rapor (Eski OKC)';
			case 10 :
				return 'Mali Rapor (Yeni OKC)';
			case 121:
				return 'E-Defter İkincil Kopya';
			case 122:
				return 'E-Gider Pusulası';
			case 12:
				return 'E-Adisyon';
			case 77:
				return 'İK Platformu';
			case 99:
				return 'Ön Muhasebe';
			case 13:
				return 'E-Belge';
			case 123:
				return 'E-Konnektör';
			case 11:
				return 'E-Döviz';
			case 124:
				return 'e-Arşiv 5000/3000';
			case 125:
				return 'E-Sigorta';
			case 140:
				return 'E-Ticaret';
		}
	}

	setSelectedContract(contract) {
		this.props.setSelectedContract(contract)
	}

	rateTypeAlert(data) {
		let messageText = data.rateType === 1 ? 'Faturalı' : 'Kontörlü';
		this.setState({
			alert: (
				<SweetAlertExt
					showCancel
					warning
					confirmBtnText="Evet"
					cancelBtnText="Hayır"
					confirmBtnBsStyle="danger"
					cancelBtnBsStyle="default"
					title="Emin misiniz?"
					onConfirm={() => this.switchRateType(data)}
					onCancel={() => this.setState({ alert: null })}
				>
					{'Sözleşme türü ' + messageText + " olarak değiştirilecek."}
				</SweetAlertExt>
			)
		});
	}


	switchRateType(data) {
		let self = this;
		let params = {
			url: `/customer/switchRateType`,
			method: 'post',
			data: data
		};
		request(params)
			.then(() => {
				Alert.success('Sözleşme Türü Değiştirildi', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({
					alert: null,
					tempRateType: null
				}, () => {
					this.manipulateContractRateType(data)
				});
			}).catch(function (error) {
			self.setState({alert: null});
			showAxiosError(error);
		});
	}


	manipulateContractRateType(data) {
		this.props.manipulateContractRateType(data);
	}

	manipulateContractFinishDate(data) {
		this.props.manipulateContractFinishDate(data);
	}

	renewContract(currentContract) {
		let self = this;

		let params = {
			url: `/customer/renewContract`,
			method: 'post',
			data: currentContract
		};
		request(params)
			.then(() => {
				Alert.success('Sözleşme Süresi Bir Yıl Uzatıldı', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.setState({contractRenewalAlert: null}
					, () => self.props.redefineExpiringContracts(currentContract)
					//, () => this.manipulateContractRateType(data)
				);
				self.manipulateContractFinishDate(currentContract)
			}).catch(function (error) {
			self.setState({alert: null});
			showAxiosError(error);
		});
	}

	warnUserAboutRenewal(currentContract) {

		let newFinishDate = moment(currentContract.contractFinishDate).add(1, 'YEARS').format('DD-MM-YYYY');
		this.setState({
			contractRenewalAlert: (
				<SweetAlert showCancel warning
							confirmBtnText="Evet"
							cancelBtnText="Hayır"
							confirmBtnBsStyle="danger"
							cancelBtnBsStyle="default"
							title="Onaylıyor musunuz ?"
							onConfirm={() => this.renewContract(currentContract)}
							onCancel={() => this.setState({contractRenewalAlert: null})}
				>
					{moment(currentContract.contractFinishDate).format('DD-MM-YYYY') + ' olan sözleşme bitişi, ' + newFinishDate + " tarihine kadar uzatılacak."}
				</SweetAlert>
			)
		});
	}

	render() {
		let contract = this.state.customerContract;

		let warning = false;
		let terminated = false;
		let pendingTermination = false;
		let pendingActivation = false;
		let pendingSendGib = false;
		let layout = {};

		if (contract.recordId) {
			if (this.props.expiringContracts) {
				this.props.expiringContracts.map(ec => {
					if (ec.recordId === contract.recordId) {
						warning = true;
						layout.border = '#dc0000';
						layout.borderStyle = 'double'
					}
				});
			} else {
				let ccsl = contract.customerContractServiceList;
				let cancelled = false;
				let pendingCancelSign = false;
				let pendingActivateSign = false;

				if (ccsl !== null && ccsl.length > 0) {
					let foundActiveAlias = false;

					for (let service in ccsl) {

						let al = ccsl[service].aliasList;
						if (al !== null && al.length > 0) {
							for (let alias in al) {
								if (!(al[alias].actionType === 'C' && al[alias].processState === 500 && al[alias].processResult === 1300)) {
									foundActiveAlias = true;

									if (al[alias].processState <= 130 && al[alias].processResult === 0 && al[alias].actionType === 'C') {
										pendingCancelSign = true;
									}

									if (al[alias].processState <= 130 && al[alias].processResult === 0 && al[alias].actionType === 'P') {
										pendingActivateSign = true;
									}

									if (al[alias].processState === 180 && al[alias].processResult === 0 && al[alias].actionType === 'P') {
										pendingSendGib = true;
									}
								}
							}
						}
					}

					if (foundActiveAlias === false && pendingCancelSign === false) {
						cancelled = true;
					}
				}

				if (cancelled) {
					layout.background = '#cd6e6e61';
					layout.color = '#A1A1A1';
					layout.fontSize = '10px';
					terminated = true;
				}

				if (pendingCancelSign) {
					layout.background = '#fffb5fad';
					layout.color = '#A1A1A1';
					layout.fontSize = '10px';
					pendingTermination = true;
				}

				if (pendingActivateSign || pendingSendGib) {
					layout.background = '#7fff5fad';
					layout.color = '#A1A1A1';
					layout.fontSize = '10px';
					pendingActivation = true;
				}
			}
		}

		return (
			<div>
				{this.state.alert}
				{this.state.resendAlert}
				{this.state.contractRenewalAlert}
				<Accordion>
					<AccordionItem onClick={() => this.setSelectedContract(contract)}>
						<AccordionItemTitle id={'accordion-item-title-' + contract.recordId} style={layout}>
							<div className='col-sm-12 row'>

								{terminated &&
									<Col id={'cancelled-contract-warning-' + contract.recordId} xs='12'>
										<p style={{
											fontSize: '15px',
											padding: '0 0 0 15px',
											fontStyle: 'italic',
											color: 'red'
										}}>
											Sözleşme İptal Edilmiş
										</p>
									</Col>}

								{pendingTermination &&
									<Col xs='12'>
										<p style={{
											fontSize: '15px',
											padding: '0 0 0 15px',
											fontStyle: 'italic',
											color: '#ff9e00'
										}}>
											İptal Talebi Gönderildi, İmza Bekleniyor
										</p>
									</Col>}

								<Col xs='12' id={'fake-cancel-warning-' + contract.recordId} style={{display: 'none'}}>
									<p style={{
										fontSize: '15px',
										padding: '0 0 0 15px',
										fontStyle: 'italic',
										color: '#ff9e00'
									}}>
										İptal Talebi Gönderildi, İmza Bekleniyor
									</p>
								</Col>

								{pendingActivation &&
									<Col xs='12'>
										<p style={{
											fontSize: '15px',
											padding: '0 0 0 15px',
											fontStyle: 'italic',
											color: '#2bb738'
										}}>
											{pendingSendGib ? "İmzalama yapıldı. GİB gönderimi bekleniyor." : "Aktivasyon Talebi Gönderildi, İmza Bekleniyor"}
										</p>
									</Col>}

								<Col xs='12' id={'fake-activate-warning-' + contract.recordId}
									 style={{display: 'none'}}>
									<p style={{
										fontSize: '15px',
										padding: '0 0 0 15px',
										fontStyle: 'italic',
										color: '#2bb738'
									}}>
										Aktivasyon Talebi Gönderildi, İmza Bekleniyor
									</p>
								</Col>

								<div className='accordion__arrow'></div>
								<div className='col-sm-5'>
									<div className='col-sm-12'>
										<label>Sözleşme Tarihi</label>
									</div>
									<div className='col-sm-12' style={{maxWidth: 'none'}}>
										<h6 style={{color: warning && '#dc0000'}}>({moment(contract.contractStartDate).format('DD-MM-YYYY')})
											-
											({moment(contract.contractFinishDate).format('DD-MM-YYYY')})</h6>
									</div>
								</div>
								<div className='col-sm-4'>
									<div className='col-sm-12'>
										<label>Hizmetler</label>
									</div>
									<div className='col-sm-12' style={{maxWidth: 'none'}}>
										<label
											style={{fontWeight: 'bold'}}>{this.previewServices(contract, false)}</label>
									</div>
								</div>

								<div className='col-sm-3'>
									<div className='col-sm-12'>
										<label className="col-form-label" style={{marginBottom: '-2px'}}>Sözleşme
											Türü</label>
									</div>
									<div className='col-sm-12 row' style={{maxWidth: 'none'}}>
										<div className='col-sm-5'>
											<label style={{fontWeight: 'bold'}}>
												{(contract.rateType?.value || contract.rateType) === 1 ? 'Faturalı' :
													(contract.rateType?.value || contract.rateType) === 2 ? 'Kontörlü' :
														'Seçiniz'}

											</label>
										</div>

										{(this.props.currentUser.entegrator &&
													this.props.currentUser.adminUser &&
													!terminated &&
													this.props.currentUser.roleId !== 5 &&
													this.props.currentUser.roleId !== 3 &&
													this.props.currentUser.roleId !== 4 &&
												    this.props.impersonateUserRoleId !== 3 &&
													this.props.impersonateUserRoleId !== 4) &&
											<div className='col-sm-7 form-group'>
												<select
													className='form-control'
													style={{
														height: '32px',
														fontSize: '12px', 
														fontWeight: '500',
														color: '#000',
														borderColor: '#ccc'
													}}
													value={this.state.tempRateType || contract.rateType?.value || contract.rateType || ''}
													onClick={(e) => e.stopPropagation()}
													onFocus={(e) => e.stopPropagation()}
													onChange={(e) => {
														e.stopPropagation();
														const newRateType = parseInt(e.target.value);

														this.setState({tempRateType: newRateType});

														this.rateTypeAlert({
															...contract,
															rateType: newRateType
														});
													}}
													required
												>
													<option value='' disabled>Seçiniz</option>
													<option value='1'>Faturalı</option>
													<option value='2'>Kontörlü</option>
												</select>

											</div>
										}
									</div>
								</div>
							</div>

							{warning &&
								<div className='col-sm-12 row'>
									<div className='col-sm-6 row' style={{paddingLeft: '45px'}}>
										<div className='col-sm-1' style={{padding: '0px', textAlign: 'right'}}>
											<MiniButton faIcon="fa-angle-up"
														style={{background: '#dc0000', borderRadius: '20px'}}
														onClick={() => this.warnUserAboutRenewal(contract)}/>
										</div>
										<div className='col-sm-5' style={{padding: '3px 0 0 5px'}}>
											<label style={{color: '#dc0000', verticalAlign: 'sub'}}>Sözleşmeyi 1(bir)
												yıl uzat</label>
										</div>
									</div>
								</div>
							}


						</AccordionItemTitle>
						<AccordionItemBody id={'accordion-body-' + contract.recordId} className='accordion-body'
										   style={{background: terminated ? '#cd6e6e61' : (pendingTermination ? '#fffb5fad' : (pendingActivation ? '#7fff5fad' : ''))}}>
							<div style={{margin: '0 0 40px 0'}}>
								{this.defineBody(contract)}
								{this.defineAliasList(contract)}
							</div>
						</AccordionItemBody>
					</AccordionItem>
				</Accordion>
				{this.state.mediaModal &&
					<MediaViewer modal={this.state.mediaModal}
								 url={this.state.url}
								 title={this.state.title}
								 listener={this.setMediaViewer}
					/>
				}
				{this.state.aliasEditModal &&
					<AliasEditModal modal={this.state.aliasEditModal}
									toggle={() => this.setState({aliasForUpdate: null, aliasEditModal: false})}
									disableButtons={() => this.setState({aliasUpdateModalButtonsDisabled: true})}
									aliasForUpdate={this.state.aliasForUpdate}
									updateAlias={this.updateAlias}
									aliasUpdateModalButtonsDisabled={this.state.aliasUpdateModalButtonsDisabled}/>

				}

			</div>
		)
	}
}

export default CustomerContractAccordion;